import { followUpItems } from '@/mocks/home'
import SectionHeading from './SectionHeading'

export default function FollowUpSection() {
  return (
    <section id="follow-up" className="border-b border-background-200/80 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Follow Ups"
          title="蹲一个后续 · 更新流"
          desc="从话题起点到最新进展，按时间倒序摆在这里。不用反复刷，来了就能接上上一次的进度。"
        />

        <div className="relative">
          <div className="absolute left-[7px] top-2 hidden h-[calc(100%-1rem)] w-[2px] bg-background-200 md:block"></div>

          <ol className="space-y-6 md:space-y-8">
            {followUpItems.map((item, index) => (
              <li key={item.id} className="relative md:pl-10">
                <span
                  className={`absolute left-0 top-1.5 hidden h-4 w-4 items-center justify-center rounded-full border-2 md:flex ${
                    index === 0
                      ? 'border-primary-500 bg-primary-500'
                      : 'border-background-300 bg-background-50'
                  }`}
                >
                  {index === 0 && <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>}
                </span>

                <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:bg-background-100/60 md:p-6">
                  <div className="mb-3 flex flex-wrap items-center gap-3">
                    <span className="font-label text-xs tracking-wide text-foreground-500">{item.stamp}</span>
                    <span
                      className={`rounded-md px-2 py-0.5 font-label text-[11px] font-medium ${
                        index === 0
                          ? 'bg-primary-100 text-primary-800'
                          : 'bg-secondary-100 text-secondary-800'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-[17px]">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-8 flex justify-center md:justify-start md:pl-10">
            <a
              href="#subscribe"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
            >
              <i className="ri-notification-3-line text-base"></i>
              有新后续时提醒我
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}